import React from 'react';
import PropTypes from 'prop-types';
import classNames from '@jd/jmtd-tools/es/classnames';

function TooltipIndex(_ref) {
  var color = _ref.color,
      name = _ref.name,
      value = _ref.value,
      isMini = _ref.isMini;
  return /*#__PURE__*/React.createElement("div", {
    className: "jmtc-tooltip-item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "jmtc-tooltip-index-container"
  }, !isMini && /*#__PURE__*/React.createElement("span", {
    className: "jmtc-tooltip-index-icon",
    style: {
      background: color
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "jmtc-tooltip-index-name"
  }, name)), /*#__PURE__*/React.createElement("span", {
    className: "jmtc-tooltip-index-val"
  }, value !== null && value !== void 0 ? value : '--'));
}

TooltipIndex.propTypes = {
  color: PropTypes.string,
  name: PropTypes.node,
  value: PropTypes.node,
  isMini: PropTypes.bool
};
TooltipIndex.defaultProps = {
  color: null,
  name: null,
  value: null,
  isMini: false
};

function Tooltip(_ref2) {
  var params = _ref2.params,
      formatter = _ref2.formatter,
      data = _ref2.data,
      isMini = _ref2.isMini;
  var title;
  var content;
  var series = data.series;

  if (Array.isArray(params)) {
    // 数组
    title = params[0].axisValue;
    content = params.map(function (item, index) {
      return /*#__PURE__*/React.createElement(TooltipIndex, {
        key: index,
        color: item.color,
        name: item.seriesName,
        isMini: isMini && params.length === 1,
        value: formatter(item.value, item, series.find(function (d, i) {
          return i === item.seriesIndex;
        }))
      });
    });
  } else {
    title = params.seriesName;
    content = /*#__PURE__*/React.createElement(TooltipIndex, {
      color: params.color,
      name: (params === null || params === void 0 ? void 0 : params.name) || '-',
      isMini: isMini,
      value: formatter(params === null || params === void 0 ? void 0 : params.value, params)
    });
  }

  return /*#__PURE__*/React.createElement("div", {
    className: classNames('jmtc-tooltip-wrapper', isMini ? 'jmtc-tooltip-small-wrapper' : '')
  }, !isMini && /*#__PURE__*/React.createElement("div", {
    className: "jmtc-x-axis-babel"
  }, title), content);
}

Tooltip.propTypes = {
  data: PropTypes.object.isRequired,
  params: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  formatter: PropTypes.func,
  isMini: PropTypes.bool
};
Tooltip.defaultProps = {
  formatter: function formatter(x) {
    return x;
  },
  isMini: false
};
export default Tooltip;